import { event, GtagEvent } from "./event";

export interface Share extends GtagEvent {
    method?:string;
    content_type?:string;
    item_id?:string;
}
export const share = ($_?:Share) => event('share',$_);